import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import { Container, Row, Col } from '../src';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2 {...{
      "id": "responsive"
    }}>{`Responsive`}</h2>
    <p>{`You can create a responsive grid system by using a single set of `}<inlineCode parentName="p">{`Row`}</inlineCode>{` and `}<inlineCode parentName="p">{`Col`}</inlineCode>{` grid assembly, all of the columns (Col) must be placed in `}<inlineCode parentName="p">{`Row`}</inlineCode>{`.`}</p>
    <Playground __position={0} __code={'<Container debug>\n  <Row>\n    <Col>Col auto</Col>\n  </Row>\n  <Row>\n    <Col sm={4} md={4} lg={6}>\n      sm-4 md-4 lg-6\n    </Col>\n    <Col sm={4} md={8} lg={6}>\n      sm-4 md-8 lg-6\n    </Col>\n  </Row>\n  <Row>\n    <Col sm={2} md={3} lg={4}>\n      sm-2 md-3 lg-4\n    </Col>\n    <Col sm={2} md={3} lg={2}>\n      sm-2 md-3 lg-2\n    </Col>\n    <Col sm={2} md={3} lg={4}>\n      sm-2 md-3 lg-4\n    </Col>\n    <Col sm={2} md={3} lg={2}>\n      sm-2 md-3 lg-2\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row mdxType="Row">
      <Col mdxType="Col">Col auto</Col>
    </Row>
    <Row mdxType="Row">
      <Col sm={4} md={4} lg={6} mdxType="Col">
        sm-4 md-4 lg-6
      </Col>
      <Col sm={4} md={8} lg={6} mdxType="Col">
        sm-4 md-8 lg-6
      </Col>
    </Row>
    <Row mdxType="Row">
      <Col sm={2} md={3} lg={4} mdxType="Col">
        sm-2 md-3 lg-4
      </Col>
      <Col sm={2} md={3} lg={2} mdxType="Col">
        sm-2 md-3 lg-2
      </Col>
      <Col sm={2} md={3} lg={4} mdxType="Col">
        sm-2 md-3 lg-4
      </Col>
      <Col sm={2} md={3} lg={2} mdxType="Col">
        sm-2 md-3 lg-2
      </Col>
    </Row>
  </Container>
    </Playground>
    <h2 {...{
      "id": "column-offset"
    }}>{`Column offset`}</h2>
    <Playground __position={1} __code={'<Container debug>\n  <Row>\n    {Array.from(Array(12), (v, i) => {\n      return (\n        <Col key={i} offset={{ lg: 11 - i }} lg={i + 1}>\n          <br />\n        </Col>\n      )\n    })}\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row mdxType="Row">
      {Array.from(Array(12), (v, i) => {
            return <Col key={i} offset={{
              lg: 11 - i
            }} lg={i + 1} mdxType="Col">
            <br />
          </Col>;
          })}
    </Row>
  </Container>
    </Playground>
    <h2 {...{
      "id": "alignment"
    }}>{`Alignment`}</h2>
    <p>{`Align and justify working with flexbox and both accept a `}<strong parentName="p">{`string`}</strong>{` or `}<strong parentName="p">{`object.`}</strong></p>
    <h3 {...{
      "id": "vertical"
    }}>{`Vertical`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Props accepted: baseline | center | flex-start | flex-end | stretch.`}</p>
    </blockquote>
    <Playground __position={2} __code={'<Container debug>\n  <Row align=\"flex-start\">\n    <Col sm={4} md={6} style={{ height: \'100px\' }}>\n      start\n    </Col>\n    <Col sm={4} md={6}>\n      start\n    </Col>\n  </Row>\n  <br />\n  <Row align={{ lg: \'flex-end\', xl: \'center\' }}>\n    <Col sm={4} md={6}>\n      lg-end xl-center\n    </Col>\n    <Col sm={4} md={6} style={{ height: \'100px\' }}>\n      lg-end xl-center\n    </Col>\n  </Row>\n  <br />\n  <Row align={{ lg: \'center\', xl: \'flex-end\' }}>\n    <Col sm={4} md={6} style={{ height: \'100px\' }}>\n      lg-center xl-end\n    </Col>\n    <Col sm={4} md={6}>\n      lg-center xl-end\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row align="flex-start" mdxType="Row">
      <Col sm={4} md={6} style={{
            height: '100px'
          }} mdxType="Col">
        start
      </Col>
      <Col sm={4} md={6} mdxType="Col">
        start
      </Col>
    </Row>
    <br />
    <Row align={{
          lg: 'flex-end',
          xl: 'center'
        }} mdxType="Row">
      <Col sm={4} md={6} mdxType="Col">
        lg-end xl-center
      </Col>
      <Col sm={4} md={6} style={{
            height: '100px'
          }} mdxType="Col">
        lg-end xl-center
      </Col>
    </Row>
    <br />
    <Row align={{
          lg: 'center',
          xl: 'flex-end'
        }} mdxType="Row">
      <Col sm={4} md={6} style={{
            height: '100px'
          }} mdxType="Col">
        lg-center xl-end
      </Col>
      <Col sm={4} md={6} mdxType="Col">
        lg-center xl-end
      </Col>
    </Row>
  </Container>
    </Playground>
    <h3 {...{
      "id": "horizontal"
    }}>{`Horizontal`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Props accepted: center | flex-end | flex-start | space-around | space-between.`}</p>
    </blockquote>
    <Playground __position={3} __code={'<Container debug>\n  <Row justify=\"space-around\">\n    <Col md={3} lg={3}>\n      space around\n    </Col>\n    <Col md={3} lg={3}>\n      space around\n    </Col>\n    <Col md={3} lg={3}>\n      space around\n    </Col>\n  </Row>\n  <br />\n  <Row justify={{ lg: \'flex-end\', xl: \'center\' }}>\n    <Col md={3} lg={3}>\n      lg-end xl-center\n    </Col>\n    <Col md={3} lg={3}>\n      lg-end xl-center\n    </Col>\n    <Col md={3} lg={3}>\n      lg-end xl-center\n    </Col>\n  </Row>\n  <br />\n  <Row justify={{ lg: \'flex-start\', xl: \'space-between\' }}>\n    <Col md={3} lg={3}>\n      lg start xl-between\n    </Col>\n    <Col md={3} lg={3}>\n      lg start xl-between\n    </Col>\n    <Col md={3} lg={3}>\n      lg start xl-between\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row justify="space-around" mdxType="Row">
      <Col md={3} lg={3} mdxType="Col">
        space around
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        space around
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        space around
      </Col>
    </Row>
    <br />
    <Row justify={{
          lg: 'flex-end',
          xl: 'center'
        }} mdxType="Row">
      <Col md={3} lg={3} mdxType="Col">
        lg-end xl-center
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        lg-end xl-center
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        lg-end xl-center
      </Col>
    </Row>
    <br />
    <Row justify={{
          lg: 'flex-start',
          xl: 'space-between'
        }} mdxType="Row">
      <Col md={3} lg={3} mdxType="Col">
        lg start xl-between
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        lg start xl-between
      </Col>
      <Col md={3} lg={3} mdxType="Col">
        lg start xl-between
      </Col>
    </Row>
  </Container>
    </Playground>
    <h2 {...{
      "id": "reverse"
    }}>{`Reverse`}</h2>
    <blockquote>
      <p parentName="blockquote">{`Receives a `}<strong parentName="p">{`boolean`}</strong>{` or `}<strong parentName="p">{`array,`}</strong>{` if you pass just the boolean all breakpoints will be reversed.`}</p>
    </blockquote>
    <Playground __position={4} __code={'<Container debug>\n  <Row reverse>\n    <Col sm={2} lg={4}>\n      Col-sm-2 Col-lg-4\n    </Col>\n  </Row>\n  <Row reverse={[\'md\', \'lg\']}>\n    <Col sm={2} lg={4}>\n      Col-sm-2 Col-lg-4\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row reverse mdxType="Row">
      <Col sm={2} lg={4} mdxType="Col">
        Col-sm-2 Col-lg-4
      </Col>
    </Row>
    <Row reverse={['md', 'lg']} mdxType="Row">
      <Col sm={2} lg={4} mdxType="Col">
        Col-sm-2 Col-lg-4
      </Col>
    </Row>
  </Container>
    </Playground>
    <h2 {...{
      "id": "nesting"
    }}>{`Nesting`}</h2>
    <blockquote>
      <p parentName="blockquote">{`To nest your content with the default grid, add a new `}<inlineCode parentName="p">{`<Row>`}</inlineCode>{` and set of Columns(Col).`}</p>
    </blockquote>
    <Playground __position={5} __code={'<Container debug>\n  <Row>\n    <Col sm={8} lg={12}>\n      Col-sm-8 Col-lg-12\n      <Row>\n        <Col sm={4} lg={6}>\n          Col-sm-4 Col-lg-6\n        </Col>\n        <Col sm={4} lg={6}>\n          Col-sm-4 Col-lg-6\n        </Col>\n      </Row>\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row mdxType="Row">
      <Col sm={8} lg={12} mdxType="Col">
        Col-sm-8 Col-lg-12
        <Row mdxType="Row">
          <Col sm={4} lg={6} mdxType="Col">
            Col-sm-4 Col-lg-6
          </Col>
          <Col sm={4} lg={6} mdxType="Col">
            Col-sm-4 Col-lg-6
          </Col>
        </Row>
      </Col>
    </Row>
  </Container>
    </Playground>
    <h2 {...{
      "id": "remove-gutters"
    }}>{`Remove gutters`}</h2>
    <p>{`Remove gutters from columns`}</p>
    <Playground __position={6} __code={'<Container debug>\n  <Row noGutters>\n    <Col sm={4} md={4} lg={6}>\n      sm-4 md-4 lg-6\n    </Col>\n    <Col sm={4} md={8} lg={6}>\n      sm-4 md-8 lg-6\n    </Col>\n  </Row>\n  <Row noGutters>\n    <Col sm={2} md={3} lg={4}>\n      sm-2 md-3 lg-4\n    </Col>\n    <Col sm={2} md={3} lg={2}>\n      sm-2 md-3 lg-2\n    </Col>\n    <Col sm={2} md={3} lg={4}>\n      sm-2 md-3 lg-4\n    </Col>\n    <Col sm={2} md={3} lg={2}>\n      sm-2 md-3 lg-2\n    </Col>\n  </Row>\n</Container>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Container,
      Row,
      Col,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Container debug mdxType="Container">
    <Row noGutters mdxType="Row">
      <Col sm={4} md={4} lg={6} mdxType="Col">
        sm-4 md-4 lg-6
      </Col>
      <Col sm={4} md={8} lg={6} mdxType="Col">
        sm-4 md-8 lg-6
      </Col>
    </Row>
    <Row noGutters mdxType="Row">
      <Col sm={2} md={3} lg={4} mdxType="Col">
        sm-2 md-3 lg-4
      </Col>
      <Col sm={2} md={3} lg={2} mdxType="Col">
        sm-2 md-3 lg-2
      </Col>
      <Col sm={2} md={3} lg={4} mdxType="Col">
        sm-2 md-3 lg-4
      </Col>
      <Col sm={2} md={3} lg={2} mdxType="Col">
        sm-2 md-3 lg-2
      </Col>
    </Row>
  </Container>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      